<script lang="ts" setup>
import { computed, watch } from 'vue';

import { AppLinkButton } from '@libs/ui';
import type { IngredientId } from '@libs/trip-planner-interfaces';

import { useTripOverviewModalsStore } from '../../../stores/tripOverviewModalsStore';
import { useUpsellStore } from '../../../stores/upsell/upsellStore';

interface FerryProductCardTicketsProps {
  token: string;
  ingredientId: IngredientId;
}

const props = defineProps<FerryProductCardTicketsProps>();

interface FerryProductCardTicketsEmits {
  (eventName: 'ticket-categories-loaded'): void;
}

const emit = defineEmits<FerryProductCardTicketsEmits>();

const upsellStore = useUpsellStore();
const tripOverviewModalsStore = useTripOverviewModalsStore();

watch(
  props,
  () => {
    upsellStore.fetchTicketCategories(props.token, props.ingredientId);
  },
  { immediate: true }
);

const hasTicketCategories = computed(() => {
  const ticketCategories = upsellStore.getTicketCategories(props.token);
  const hasTicket = ticketCategories.length > 0;

  if (hasTicket) {
    emit('ticket-categories-loaded');
  }

  return hasTicket;
});
</script>

<template>
  <div v-if="hasTicketCategories" class="ferry-product-card-tickets">
    <AppLinkButton
      class="change-ticket-category-button"
      :text="$t('planner.edit')"
      size="small"
      @click="
        tripOverviewModalsStore.openChangeTicketCategoryModal(
          props.token,
          props.ingredientId
        )
      "
    />
  </div>
</template>
